import Swiper from 'swiper';
import { Pagination } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/navigation';

export default class SlideItinerary {
	constructor() {
		this.swiper = undefined;
	}

	getStandardSlideWidth() {
		const containerWidth = $('.event-itinerary__slideActive').width();
		const windowWidth = $(window).width();

		let slidesPerView = 5;
		let spaceBetween = 25;

		if (windowWidth < 768) {
			slidesPerView = 1;
			spaceBetween = 20;
		} else if (windowWidth < 1000) {
			slidesPerView = 2;
			spaceBetween = 25;
		}

		return (containerWidth - spaceBetween * (slidesPerView - 1)) / slidesPerView;
	}

	setWidths() {
		const standardWidth = this.getStandardSlideWidth();
		const spaceBetween = 25;

		$('.event-itinerary__slideItem').each(function () {
			if (!$(this).hasClass('event-itinerary__slideItemGroup')) {
				$(this).css('width', standardWidth + 'px');
			}
		});

		$('.event-itinerary__slideItemGroup').each(function () {
			const $group = $(this);
			const count = $group.find('.event-itinerary__slideItem').length;
			const groupWidth = count * standardWidth + (count - 1) * spaceBetween;
			$group.css('width', groupWidth + 'px');
		});
	}

	init() {
		if ($('.event-itinerary__slideItem').length > 1) {
			this.setWidths();

			this.swiper = new Swiper('.event-itinerary__slideActive', {
				loop: false,
				speed: 1500,
				modules: [Pagination],
				slidesPerView: 'auto',
				spaceBetween: 25,
				pagination: {
					el: '.event-itinerary__pagination',
					clickable: true,
					type: 'bullets'
				}
			});

			if (this.swiper && window.matchMedia('(min-width: 1024px)').matches) {
				const prevZone = document.querySelector('.event-itinerary__hoverZone--prev');
				const nextZone = document.querySelector('.event-itinerary__hoverZone--next');

				let hoverInterval = null;
				const SLIDE_INTERVAL = 800; // ms between slides (tweak as needed)

				const startSliding = (direction) => {
					if (hoverInterval) return;

					hoverInterval = setInterval(() => {
						if (direction === 'next') {
							this.swiper.slideNext();
						} else {
							this.swiper.slidePrev();
						}
					}, SLIDE_INTERVAL);
				};

				const stopSliding = () => {
					if (hoverInterval) {
						clearInterval(hoverInterval);
						hoverInterval = null;
					}
				};

				prevZone?.addEventListener('mouseenter', () => startSliding('prev'));
				nextZone?.addEventListener('mouseenter', () => startSliding('next'));

				prevZone?.addEventListener('mouseleave', stopSliding);
				nextZone?.addEventListener('mouseleave', stopSliding);
			}

			$(window).on('resize', () => {
				this.setWidths();
				this.swiper.update();
			});
		}
	}

	destroy() {
		if (this.swiper !== undefined) {
			this.swiper.destroy();
		}
	}
}
